import styled from 'styled-components';
import Color from '@/utils/color';

export const RecycleSymbol = styled.span`
  ::after {
    content: '♻';
  }
  color: ${Color.VytalGreen};
`;
